var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWind02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wind-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.13196 3.5C7.40662 3.19313 7.80577 3 8.25002 3C9.07844 3 9.75002 3.67157 9.75002 4.5C9.75002 5.32843 9.07844 6 8.25002 6H1.50002M9.38196 14.5C9.65662 14.8069 10.0558 15 10.5 15C11.3284 15 12 14.3284 12 13.5C12 12.6716 11.3284 12 10.5 12H1.50002M12.5729 5.25C12.9849 4.78969 13.5836 4.5 14.25 4.5C15.4927 4.5 16.5 5.50736 16.5 6.75C16.5 7.99264 15.4927 9 14.25 9H1.5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWind02);
export default __webpack_public_path__ + "static/media/wind-02.55d70691b3054a5d44579041bbc8f06d.svg";
export { ForwardRef as ReactComponent };